import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveTickets, receiveProducts } from '@ttstr/actions';
import {
  Container,
  LoadingSpinner,
  useIntl,
  Masonry,
  ProductDetailHeader,
  ContentrArea,
  Maki,
} from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { loading, tickets, products } = useShallowEqualSelector(mapStateToProps);
  const { receiveTickets, receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveTickets();
    receiveProducts();
  }, [language]);

  return (
    <article className="pb-5 ticket-listing mb-5">
      <Container className="list-page">
        <Helmet>
          <title>{t(`TICKETLISTING.TITLE`)}</title>
          <body className="ticket-listing-page" />
        </Helmet>

        <div className="stage ticket-header-image mt-2 mb-5">
          <img src={require('./assets/images/header.jpg')} alt="sarah4k Header" className="img-fluid" />
          <img src={require('./assets/images/gitter.png')} alt="sarah4k GITTER" className="img-fluid w-100 mt-3" />
        </div>

        {/* {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no tickets
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show tickets
          <Masonry
            id="product-listing"
            columnClassName="col-sm-12 col-md-6 col-lg-6"
            products={products}
            type={Maki}
            showCity
            showLocation
          />
        )} */}

        <h2 className="mb-5 superhead">TICKETS</h2>

        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.TICKETS`)} />
        ) : tickets.length === 0 ? ( // if no tickets
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show tickets
          <Masonry id="ticket-listing" products={tickets} type="list" showCity showLocation />
        )}
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { tickets } = state.Tickets;
  const { products } = state.Products;
  return {
    products,
    tickets,
  };
};

const mapDispatchToProps = {
  receiveTickets,
  receiveProducts,
};

export default React.memo(Home);
